// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BGMFiltersHeader-module__font-s-10___djnxS {
  font-size: 10px !important;
}

.BGMFiltersHeader-module__font-s-12___LdH4N {
  font-size: 12px !important;
}

.BGMFiltersHeader-module__font-s-13___DmIuV {
  font-size: 13px !important;
}

.BGMFiltersHeader-module__font-s-14___IUbt_ {
  font-size: 14px !important;
}

.BGMFiltersHeader-module__font-s-15___jRvk5 {
  font-size: 15px !important;
}

.BGMFiltersHeader-module__font-s-16___vxbZF {
  font-size: 16px !important;
}

.BGMFiltersHeader-module__font-s-18___yTuoP {
  font-size: 18px !important;
}

.BGMFiltersHeader-module__font-s-20___BRCCv {
  font-size: 20px !important;
}

.BGMFiltersHeader-module__font-s-22___kp7gB {
  font-size: 22px !important;
}

.BGMFiltersHeader-module__font-s-28___MLbc2 {
  font-size: 28px !important;
}

.BGMFiltersHeader-module__font-w-400___Dpjk6 {
  font-weight: 400 !important;
}

.BGMFiltersHeader-module__font-w-500___GdLWG {
  font-weight: 500 !important;
}

.BGMFiltersHeader-module__font-w-600___LMfm2 {
  font-weight: 600 !important;
}

.BGMFiltersHeader-module__font-w-700___gnO_n {
  font-weight: 700 !important;
}

.BGMFiltersHeader-module__p-5___JjR1k {
  padding: 5px !important;
}

.BGMFiltersHeader-module__p-12___OS8mO {
  padding: 12px !important;
}

.BGMFiltersHeader-module__p-16___avQuL {
  padding: 16px !important;
}

.BGMFiltersHeader-module__p-30___x77gq {
  padding: 30px !important;
}

.BGMFiltersHeader-module__p-b-0___PR3yi {
  padding-bottom: 0 !important;
}

.BGMFiltersHeader-module__p-b-5___dGjQa {
  padding-bottom: 5px !important;
}

.BGMFiltersHeader-module__p-b-10___uPycp {
  padding-bottom: 10px !important;
}

.BGMFiltersHeader-module__p-b-12___qXXBq {
  padding-bottom: 12px !important;
}

.BGMFiltersHeader-module__p-b-16___Lsn7S {
  padding-bottom: 16px !important;
}

.BGMFiltersHeader-module__p-b-18___WrUbv {
  padding-bottom: 18px !important;
}

.BGMFiltersHeader-module__p-b-20___AyOW1 {
  padding-bottom: 20px !important;
}

.BGMFiltersHeader-module__p-b-25___u6VVA {
  padding-bottom: 25px !important;
}

.BGMFiltersHeader-module__p-b-30___Sa50Y {
  padding-bottom: 30px !important;
}

.BGMFiltersHeader-module__p-b-50___KcvAu {
  padding-bottom: 50px !important;
}

.BGMFiltersHeader-module__p-t-0___Xygej {
  padding-top: 0 !important;
}

.BGMFiltersHeader-module__p-t-12___EY5uF {
  padding-top: 12px !important;
}

.BGMFiltersHeader-module__p-t-16___jL8X9 {
  padding-top: 16px !important;
}

.BGMFiltersHeader-module__p-t-18___DzB6W {
  padding-top: 18px !important;
}

.BGMFiltersHeader-module__p-t-20___00UAm {
  padding-top: 20px !important;
}

.BGMFiltersHeader-module__p-t-30___p4xL2 {
  padding-top: 30px !important;
}

.BGMFiltersHeader-module__p-t-40___Bh1p_ {
  padding-top: 40px !important;
}

.BGMFiltersHeader-module__p-t-50___PJLJt {
  padding-top: 50px !important;
}

.BGMFiltersHeader-module__p-l-20___Zocir {
  padding-left: 20px !important;
}

.BGMFiltersHeader-module__p-l-30___Koa0m {
  padding-left: 30px !important;
}

.BGMFiltersHeader-module__p-l-40___M4jEN {
  padding-left: 40px !important;
}

.BGMFiltersHeader-module__p-r-16___rjrFo {
  padding-right: 16px !important;
}

.BGMFiltersHeader-module__p-r-20___VP9RO {
  padding-right: 20px !important;
}

.BGMFiltersHeader-module__p-r-30___Ar_oq {
  padding-right: 30px !important;
}

.BGMFiltersHeader-module__p-r-50___NMN0g {
  padding-right: 50px !important;
}

.BGMFiltersHeader-module__p-r-60___zVwfc {
  padding-right: 60px !important;
}

.BGMFiltersHeader-module__m-b-1___UL1SI {
  margin-bottom: 1px !important;
}

.BGMFiltersHeader-module__m-b-2___o7RTB {
  margin-bottom: 2px !important;
}

.BGMFiltersHeader-module__m-b-6___B3krm {
  margin-bottom: 6px !important;
}

.BGMFiltersHeader-module__m-b-8___Fvxwy {
  margin-bottom: 8px !important;
}

.BGMFiltersHeader-module__m-b-10___FDffS {
  margin-bottom: 10px !important;
}

.BGMFiltersHeader-module__m-b-14___xJ6io {
  margin-bottom: 14px !important;
}

.BGMFiltersHeader-module__m-b-16___tutxF {
  margin-bottom: 16px !important;
}

.BGMFiltersHeader-module__m-b-20___mPm6X {
  margin-bottom: 20px !important;
}

.BGMFiltersHeader-module__m-b-22___mYiyA {
  margin-bottom: 22px !important;
}

.BGMFiltersHeader-module__m-b-24___dbS6z {
  margin-bottom: 24px !important;
}

.BGMFiltersHeader-module__m-b-30___mVW4Y {
  margin-bottom: 30px !important;
}

.BGMFiltersHeader-module__m-b-32___iXLZh {
  margin-bottom: 32px !important;
}

.BGMFiltersHeader-module__m-b-40___UOzPs {
  margin-bottom: 40px !important;
}

.BGMFiltersHeader-module__m-t-2___uHIXW {
  margin-top: 2px !important;
}

.BGMFiltersHeader-module__m-t-3___cLy9K {
  margin-top: 3px !important;
}

.BGMFiltersHeader-module__m-t-4___JO1Qz {
  margin-top: 4px !important;
}

.BGMFiltersHeader-module__m-t-5___hbPrx {
  margin-top: 5px !important;
}

.BGMFiltersHeader-module__m-t-8___N_DsR {
  margin-top: 8px !important;
}

.BGMFiltersHeader-module__m-t-10___uxCVZ {
  margin-top: 10px !important;
}

.BGMFiltersHeader-module__m-t-15___rfqkl {
  margin-top: 15px !important;
}

.BGMFiltersHeader-module__m-t-16___hV_vn {
  margin-top: 16px !important;
}

.BGMFiltersHeader-module__m-t-20___Rpytz {
  margin-top: 20px !important;
}

.BGMFiltersHeader-module__m-t-22___DNnAW {
  margin-top: 22px !important;
}

.BGMFiltersHeader-module__m-t-30___yDpVV {
  margin-top: 30px !important;
}

.BGMFiltersHeader-module__m-t-32___VbnyM {
  margin-top: 32px !important;
}

.BGMFiltersHeader-module__m-l-auto___jkr4y {
  margin-left: auto !important;
}

.BGMFiltersHeader-module__m-l-4___ERLJ1 {
  margin-left: 4px !important;
}

.BGMFiltersHeader-module__m-l-5___dKWps {
  margin-left: 5px !important;
}

.BGMFiltersHeader-module__m-l-6___FJeOz {
  margin-left: 6px !important;
}

.BGMFiltersHeader-module__m-l-8___uY0ln {
  margin-left: 8px !important;
}

.BGMFiltersHeader-module__m-l-10___XOmQT {
  margin-left: 10px !important;
}

.BGMFiltersHeader-module__m-l-16___zFz45 {
  margin-left: 16px !important;
}

.BGMFiltersHeader-module__m-l-20___Ragk3 {
  margin-left: 20px !important;
}

.BGMFiltersHeader-module__m-l-24___XgTRD {
  margin-left: 24px !important;
}

.BGMFiltersHeader-module__m-l-30___MHmcU {
  margin-left: 30px !important;
}

.BGMFiltersHeader-module__m-l-35___M2tYh {
  margin-left: 35px !important;
}

.BGMFiltersHeader-module__m-l-40___q2mGe {
  margin-left: 40px !important;
}

.BGMFiltersHeader-module__m-r-8___ZnJdY {
  margin-right: 8px !important;
}

.BGMFiltersHeader-module__m-r-10___fDNCQ {
  margin-right: 10px !important;
}

.BGMFiltersHeader-module__m-r-16____vTVu {
  margin-right: 16px !important;
}

.BGMFiltersHeader-module__m-r-20___PkU1I {
  margin-right: 20px !important;
}

.BGMFiltersHeader-module__m-r-24___IVbsv {
  margin-right: 24px !important;
}

.BGMFiltersHeader-module__m-r-30___ZU0HD {
  margin-right: 30px !important;
}

.BGMFiltersHeader-module__m-r-40____vWsJ {
  margin-right: 40px !important;
}

.BGMFiltersHeader-module__border-r-3___EuvBK {
  border-radius: 3px !important;
}

.BGMFiltersHeader-module__border-r-4___x0XXZ {
  border-radius: 4px !important;
}

.BGMFiltersHeader-module__border-r-6___GDpri {
  border-radius: 6px !important;
}

.BGMFiltersHeader-module__border-r-10___IeaZ7 {
  border-radius: 10px !important;
}

.BGMFiltersHeader-module__border-r-12___GiI_O {
  border-radius: 12px !important;
}

.BGMFiltersHeader-module__border-r-16___ARTV_ {
  border-radius: 16px !important;
}

.BGMFiltersHeader-module__border-r-50___luyK0 {
  border-radius: 50% !important;
}

.BGMFiltersHeader-module__primary-border___p5Qd4 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMFiltersHeader-module__primary-border-b___srZKt {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMFiltersHeader-module__primary-border-t___vUpBe {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMFiltersHeader-module__primary-border-l___FDgdO {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMFiltersHeader-module__primary-border-r___w2q9M {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMFiltersHeader-module__secondary-border___QUzFT {
  border: 1px solid #637768;
}

.BGMFiltersHeader-module__secondary-border-b___ezjQb {
  border-bottom: 1px solid #637768;
}

.BGMFiltersHeader-module__secondary-border-t___YkrLi {
  border-top: 1px solid #637768;
}

.BGMFiltersHeader-module__secondary-border-l___PSOgB {
  border-left: 1px solid #637768;
}

.BGMFiltersHeader-module__secondary-border-r___D9ynj {
  border-right: 1px solid #637768;
}

.BGMFiltersHeader-module__gap-0___lyacy {
  gap: 0 !important;
}

.BGMFiltersHeader-module__gap-2___LEodr {
  gap: 2px !important;
}

.BGMFiltersHeader-module__gap-4___EZ5HO {
  gap: 4px !important;
}

.BGMFiltersHeader-module__gap-5___aH4c6 {
  gap: 5px !important;
}

.BGMFiltersHeader-module__gap-6___P4Mw_ {
  gap: 6px !important;
}

.BGMFiltersHeader-module__gap-8___tB34P {
  gap: 8px !important;
}

.BGMFiltersHeader-module__gap-10___S3XyM {
  gap: 10px !important;
}

.BGMFiltersHeader-module__gap-12___D3Ivr {
  gap: 12px !important;
}

.BGMFiltersHeader-module__gap-14___FkZgj {
  gap: 14px !important;
}

.BGMFiltersHeader-module__gap-16___ZWXNZ {
  gap: 16px !important;
}

.BGMFiltersHeader-module__gap-18___znWsn {
  gap: 18px !important;
}

.BGMFiltersHeader-module__gap-20____3lml {
  gap: 20px !important;
}

.BGMFiltersHeader-module__gap-24___Wbya9 {
  gap: 24px !important;
}

.BGMFiltersHeader-module__gap-26___NVNgg {
  gap: 26px !important;
}

.BGMFiltersHeader-module__gap-30___uHywS {
  gap: 30px !important;
}

.BGMFiltersHeader-module__gap-32___u759V {
  gap: 32px !important;
}

.BGMFiltersHeader-module__gap-40___Xr8X_ {
  gap: 40px !important;
}

.BGMFiltersHeader-module__gap-50___ciOAY {
  gap: 50px !important;
}

.BGMFiltersHeader-module__flex-1___q0t_0 {
  flex: 1;
}

.BGMFiltersHeader-module__flex-none___wskMG {
  flex: none !important;
}

.BGMFiltersHeader-module__flex-column___K_wPs {
  display: flex;
  flex-direction: column !important;
}

.BGMFiltersHeader-module__flex-row___ixPio {
  display: flex;
  flex-direction: row !important;
}

.BGMFiltersHeader-module__vertically-centered___BoQZt {
  display: flex;
  align-items: center !important;
}

.BGMFiltersHeader-module__horizontally-centered___G7Mmw {
  display: flex;
  justify-content: center !important;
}

.BGMFiltersHeader-module__horizontally-end___dsMJy {
  display: flex;
  justify-content: end !important;
}

.BGMFiltersHeader-module__vertically-start___wFHID {
  display: flex;
  align-items: start !important;
}

.BGMFiltersHeader-module__space-between___srn85 {
  display: flex;
  justify-content: space-between !important;
}

.BGMFiltersHeader-module__flex-wrap___zRtSa {
  flex-wrap: wrap !important;
}

.BGMFiltersHeader-module__height-100___NWbJD {
  height: 100%;
}

.BGMFiltersHeader-module__width-50___LKKJR {
  width: 50% !important;
}

.BGMFiltersHeader-module__width-100___tNsy5 {
  width: 100%;
}

.BGMFiltersHeader-module__cursor-pointer___LD8fD {
  cursor: pointer;
}

.BGMFiltersHeader-module__cursor-not-allowed___hgeEq {
  cursor: not-allowed !important;
}

.BGMFiltersHeader-module__absolute-centered___blX4K {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.BGMFiltersHeader-module__absolute___jtwb4 {
  position: absolute;
}

.BGMFiltersHeader-module__relative___nCs2Z {
  position: relative;
}

.BGMFiltersHeader-module__fixed___JBpiE {
  position: fixed;
}

.BGMFiltersHeader-module__visible___jzERX {
  opacity: 1;
}

.BGMFiltersHeader-module__invisible___u1Ofe {
  opacity: 0;
}

.BGMFiltersHeader-module__col-90___Qrr1y {
  width: 90% !important;
}

.BGMFiltersHeader-module__col-auto___bV_Jv {
  width: auto !important;
}

.BGMFiltersHeader-module__medical-tabs___d5882 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.BGMFiltersHeader-module__medical-table-new___sqRth {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMFiltersHeader-module__medical-table-new___sqRth:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMFiltersHeader-module__medical-table-new___sqRth::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMFiltersHeader-module__medical-table-new___sqRth::-webkit-scrollbar-track {
  display: none;
}
.BGMFiltersHeader-module__medical-table-new___sqRth.BGMFiltersHeader-module__no-pagination___cZFHc {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMFiltersHeader-module__medical-table-new___sqRth.BGMFiltersHeader-module__no-pagination___cZFHc:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMFiltersHeader-module__medical-table-new___sqRth.BGMFiltersHeader-module__no-pagination___cZFHc::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMFiltersHeader-module__medical-table-new___sqRth.BGMFiltersHeader-module__no-pagination___cZFHc::-webkit-scrollbar-track {
  display: none;
}

.BGMFiltersHeader-module__medical-table-empty___WsxMW {
  padding: 14px 40px !important;
}

.BGMFiltersHeader-module__icon-btn___o6F3u {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.BGMFiltersHeader-module__search-icon___I3Vzs {
  width: 24px;
  height: 24px;
  align-self: center;
}

.BGMFiltersHeader-module__disable-select___VbXce {
  user-select: none;
}

.BGMFiltersHeader-module__break-word___XV7c3 {
  word-break: break-word;
}

.BGMFiltersHeader-module__popup-clear-btn___f3EuA {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.BGMFiltersHeader-module__scroll-m-b-20___WOFrO {
  scroll-margin-bottom: 20px;
}

.BGMFiltersHeader-module__container___kWULm {
  width: 95%;
  justify-content: space-between;
}
.BGMFiltersHeader-module__container___kWULm .BGMFiltersHeader-module__filters___mq9yd {
  display: grid;
  column-gap: 10px;
  grid-template-columns: 370px 260px 160px;
}
.BGMFiltersHeader-module__container___kWULm .BGMFiltersHeader-module__filters___mq9yd .BGMFiltersHeader-module__date___JC3uC {
  padding: 3.5px 10px;
}
.BGMFiltersHeader-module__container___kWULm .BGMFiltersHeader-module__filters___mq9yd .BGMFiltersHeader-module__select___wq49Z > div:first-child {
  padding: 4.5px !important;
}
.BGMFiltersHeader-module__container___kWULm .BGMFiltersHeader-module__text___hEQCX {
  color: white;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: #f1bf72;
  align-self: flex-start;
  border-radius: 17px;
  line-height: 150%;
  padding: 2px 8px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/headers/BGMFiltersHeader/BGMFiltersHeader.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,UAAA;EACA,8BAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,gBAAA;EACA,wCAAA;AA8pBJ;AA5pBI;EACE,mBAAA;AA8pBN;AA1pBM;EACE,yBAAA;AA4pBR;AAvpBE;EACE,YAAA;EACA,oCAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAypBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  width: 95%;\n  justify-content: space-between;\n\n  .filters {\n    display: grid;\n    column-gap: 10px;\n    grid-template-columns: 370px 260px 160px;\n\n    .date {\n      padding: 3.5px 10px;\n    }\n\n    .select {\n      & > div:first-child {\n        padding: 4.5px !important;\n      }\n    }\n  }\n\n  .text {\n    color: get-color(white);\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    background-color: get-color(orangeNew, base);\n    align-self: flex-start;\n    border-radius: 17px;\n    line-height: 150%;\n    padding: 2px 8px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `BGMFiltersHeader-module__font-s-10___djnxS`,
	"fontS12": `BGMFiltersHeader-module__font-s-12___LdH4N`,
	"fontS13": `BGMFiltersHeader-module__font-s-13___DmIuV`,
	"fontS14": `BGMFiltersHeader-module__font-s-14___IUbt_`,
	"fontS15": `BGMFiltersHeader-module__font-s-15___jRvk5`,
	"fontS16": `BGMFiltersHeader-module__font-s-16___vxbZF`,
	"fontS18": `BGMFiltersHeader-module__font-s-18___yTuoP`,
	"fontS20": `BGMFiltersHeader-module__font-s-20___BRCCv`,
	"fontS22": `BGMFiltersHeader-module__font-s-22___kp7gB`,
	"fontS28": `BGMFiltersHeader-module__font-s-28___MLbc2`,
	"fontW400": `BGMFiltersHeader-module__font-w-400___Dpjk6`,
	"fontW500": `BGMFiltersHeader-module__font-w-500___GdLWG`,
	"fontW600": `BGMFiltersHeader-module__font-w-600___LMfm2`,
	"fontW700": `BGMFiltersHeader-module__font-w-700___gnO_n`,
	"p5": `BGMFiltersHeader-module__p-5___JjR1k`,
	"p12": `BGMFiltersHeader-module__p-12___OS8mO`,
	"p16": `BGMFiltersHeader-module__p-16___avQuL`,
	"p30": `BGMFiltersHeader-module__p-30___x77gq`,
	"pB0": `BGMFiltersHeader-module__p-b-0___PR3yi`,
	"pB5": `BGMFiltersHeader-module__p-b-5___dGjQa`,
	"pB10": `BGMFiltersHeader-module__p-b-10___uPycp`,
	"pB12": `BGMFiltersHeader-module__p-b-12___qXXBq`,
	"pB16": `BGMFiltersHeader-module__p-b-16___Lsn7S`,
	"pB18": `BGMFiltersHeader-module__p-b-18___WrUbv`,
	"pB20": `BGMFiltersHeader-module__p-b-20___AyOW1`,
	"pB25": `BGMFiltersHeader-module__p-b-25___u6VVA`,
	"pB30": `BGMFiltersHeader-module__p-b-30___Sa50Y`,
	"pB50": `BGMFiltersHeader-module__p-b-50___KcvAu`,
	"pT0": `BGMFiltersHeader-module__p-t-0___Xygej`,
	"pT12": `BGMFiltersHeader-module__p-t-12___EY5uF`,
	"pT16": `BGMFiltersHeader-module__p-t-16___jL8X9`,
	"pT18": `BGMFiltersHeader-module__p-t-18___DzB6W`,
	"pT20": `BGMFiltersHeader-module__p-t-20___00UAm`,
	"pT30": `BGMFiltersHeader-module__p-t-30___p4xL2`,
	"pT40": `BGMFiltersHeader-module__p-t-40___Bh1p_`,
	"pT50": `BGMFiltersHeader-module__p-t-50___PJLJt`,
	"pL20": `BGMFiltersHeader-module__p-l-20___Zocir`,
	"pL30": `BGMFiltersHeader-module__p-l-30___Koa0m`,
	"pL40": `BGMFiltersHeader-module__p-l-40___M4jEN`,
	"pR16": `BGMFiltersHeader-module__p-r-16___rjrFo`,
	"pR20": `BGMFiltersHeader-module__p-r-20___VP9RO`,
	"pR30": `BGMFiltersHeader-module__p-r-30___Ar_oq`,
	"pR50": `BGMFiltersHeader-module__p-r-50___NMN0g`,
	"pR60": `BGMFiltersHeader-module__p-r-60___zVwfc`,
	"mB1": `BGMFiltersHeader-module__m-b-1___UL1SI`,
	"mB2": `BGMFiltersHeader-module__m-b-2___o7RTB`,
	"mB6": `BGMFiltersHeader-module__m-b-6___B3krm`,
	"mB8": `BGMFiltersHeader-module__m-b-8___Fvxwy`,
	"mB10": `BGMFiltersHeader-module__m-b-10___FDffS`,
	"mB14": `BGMFiltersHeader-module__m-b-14___xJ6io`,
	"mB16": `BGMFiltersHeader-module__m-b-16___tutxF`,
	"mB20": `BGMFiltersHeader-module__m-b-20___mPm6X`,
	"mB22": `BGMFiltersHeader-module__m-b-22___mYiyA`,
	"mB24": `BGMFiltersHeader-module__m-b-24___dbS6z`,
	"mB30": `BGMFiltersHeader-module__m-b-30___mVW4Y`,
	"mB32": `BGMFiltersHeader-module__m-b-32___iXLZh`,
	"mB40": `BGMFiltersHeader-module__m-b-40___UOzPs`,
	"mT2": `BGMFiltersHeader-module__m-t-2___uHIXW`,
	"mT3": `BGMFiltersHeader-module__m-t-3___cLy9K`,
	"mT4": `BGMFiltersHeader-module__m-t-4___JO1Qz`,
	"mT5": `BGMFiltersHeader-module__m-t-5___hbPrx`,
	"mT8": `BGMFiltersHeader-module__m-t-8___N_DsR`,
	"mT10": `BGMFiltersHeader-module__m-t-10___uxCVZ`,
	"mT15": `BGMFiltersHeader-module__m-t-15___rfqkl`,
	"mT16": `BGMFiltersHeader-module__m-t-16___hV_vn`,
	"mT20": `BGMFiltersHeader-module__m-t-20___Rpytz`,
	"mT22": `BGMFiltersHeader-module__m-t-22___DNnAW`,
	"mT30": `BGMFiltersHeader-module__m-t-30___yDpVV`,
	"mT32": `BGMFiltersHeader-module__m-t-32___VbnyM`,
	"mLAuto": `BGMFiltersHeader-module__m-l-auto___jkr4y`,
	"mL4": `BGMFiltersHeader-module__m-l-4___ERLJ1`,
	"mL5": `BGMFiltersHeader-module__m-l-5___dKWps`,
	"mL6": `BGMFiltersHeader-module__m-l-6___FJeOz`,
	"mL8": `BGMFiltersHeader-module__m-l-8___uY0ln`,
	"mL10": `BGMFiltersHeader-module__m-l-10___XOmQT`,
	"mL16": `BGMFiltersHeader-module__m-l-16___zFz45`,
	"mL20": `BGMFiltersHeader-module__m-l-20___Ragk3`,
	"mL24": `BGMFiltersHeader-module__m-l-24___XgTRD`,
	"mL30": `BGMFiltersHeader-module__m-l-30___MHmcU`,
	"mL35": `BGMFiltersHeader-module__m-l-35___M2tYh`,
	"mL40": `BGMFiltersHeader-module__m-l-40___q2mGe`,
	"mR8": `BGMFiltersHeader-module__m-r-8___ZnJdY`,
	"mR10": `BGMFiltersHeader-module__m-r-10___fDNCQ`,
	"mR16": `BGMFiltersHeader-module__m-r-16____vTVu`,
	"mR20": `BGMFiltersHeader-module__m-r-20___PkU1I`,
	"mR24": `BGMFiltersHeader-module__m-r-24___IVbsv`,
	"mR30": `BGMFiltersHeader-module__m-r-30___ZU0HD`,
	"mR40": `BGMFiltersHeader-module__m-r-40____vWsJ`,
	"borderR3": `BGMFiltersHeader-module__border-r-3___EuvBK`,
	"borderR4": `BGMFiltersHeader-module__border-r-4___x0XXZ`,
	"borderR6": `BGMFiltersHeader-module__border-r-6___GDpri`,
	"borderR10": `BGMFiltersHeader-module__border-r-10___IeaZ7`,
	"borderR12": `BGMFiltersHeader-module__border-r-12___GiI_O`,
	"borderR16": `BGMFiltersHeader-module__border-r-16___ARTV_`,
	"borderR50": `BGMFiltersHeader-module__border-r-50___luyK0`,
	"primaryBorder": `BGMFiltersHeader-module__primary-border___p5Qd4`,
	"primaryBorderB": `BGMFiltersHeader-module__primary-border-b___srZKt`,
	"primaryBorderT": `BGMFiltersHeader-module__primary-border-t___vUpBe`,
	"primaryBorderL": `BGMFiltersHeader-module__primary-border-l___FDgdO`,
	"primaryBorderR": `BGMFiltersHeader-module__primary-border-r___w2q9M`,
	"secondaryBorder": `BGMFiltersHeader-module__secondary-border___QUzFT`,
	"secondaryBorderB": `BGMFiltersHeader-module__secondary-border-b___ezjQb`,
	"secondaryBorderT": `BGMFiltersHeader-module__secondary-border-t___YkrLi`,
	"secondaryBorderL": `BGMFiltersHeader-module__secondary-border-l___PSOgB`,
	"secondaryBorderR": `BGMFiltersHeader-module__secondary-border-r___D9ynj`,
	"gap0": `BGMFiltersHeader-module__gap-0___lyacy`,
	"gap2": `BGMFiltersHeader-module__gap-2___LEodr`,
	"gap4": `BGMFiltersHeader-module__gap-4___EZ5HO`,
	"gap5": `BGMFiltersHeader-module__gap-5___aH4c6`,
	"gap6": `BGMFiltersHeader-module__gap-6___P4Mw_`,
	"gap8": `BGMFiltersHeader-module__gap-8___tB34P`,
	"gap10": `BGMFiltersHeader-module__gap-10___S3XyM`,
	"gap12": `BGMFiltersHeader-module__gap-12___D3Ivr`,
	"gap14": `BGMFiltersHeader-module__gap-14___FkZgj`,
	"gap16": `BGMFiltersHeader-module__gap-16___ZWXNZ`,
	"gap18": `BGMFiltersHeader-module__gap-18___znWsn`,
	"gap20": `BGMFiltersHeader-module__gap-20____3lml`,
	"gap24": `BGMFiltersHeader-module__gap-24___Wbya9`,
	"gap26": `BGMFiltersHeader-module__gap-26___NVNgg`,
	"gap30": `BGMFiltersHeader-module__gap-30___uHywS`,
	"gap32": `BGMFiltersHeader-module__gap-32___u759V`,
	"gap40": `BGMFiltersHeader-module__gap-40___Xr8X_`,
	"gap50": `BGMFiltersHeader-module__gap-50___ciOAY`,
	"flex1": `BGMFiltersHeader-module__flex-1___q0t_0`,
	"flexNone": `BGMFiltersHeader-module__flex-none___wskMG`,
	"flexColumn": `BGMFiltersHeader-module__flex-column___K_wPs`,
	"flexRow": `BGMFiltersHeader-module__flex-row___ixPio`,
	"verticallyCentered": `BGMFiltersHeader-module__vertically-centered___BoQZt`,
	"horizontallyCentered": `BGMFiltersHeader-module__horizontally-centered___G7Mmw`,
	"horizontallyEnd": `BGMFiltersHeader-module__horizontally-end___dsMJy`,
	"verticallyStart": `BGMFiltersHeader-module__vertically-start___wFHID`,
	"spaceBetween": `BGMFiltersHeader-module__space-between___srn85`,
	"flexWrap": `BGMFiltersHeader-module__flex-wrap___zRtSa`,
	"height100": `BGMFiltersHeader-module__height-100___NWbJD`,
	"width50": `BGMFiltersHeader-module__width-50___LKKJR`,
	"width100": `BGMFiltersHeader-module__width-100___tNsy5`,
	"cursorPointer": `BGMFiltersHeader-module__cursor-pointer___LD8fD`,
	"cursorNotAllowed": `BGMFiltersHeader-module__cursor-not-allowed___hgeEq`,
	"absoluteCentered": `BGMFiltersHeader-module__absolute-centered___blX4K`,
	"absolute": `BGMFiltersHeader-module__absolute___jtwb4`,
	"relative": `BGMFiltersHeader-module__relative___nCs2Z`,
	"fixed": `BGMFiltersHeader-module__fixed___JBpiE`,
	"visible": `BGMFiltersHeader-module__visible___jzERX`,
	"invisible": `BGMFiltersHeader-module__invisible___u1Ofe`,
	"col90": `BGMFiltersHeader-module__col-90___Qrr1y`,
	"colAuto": `BGMFiltersHeader-module__col-auto___bV_Jv`,
	"medicalTabs": `BGMFiltersHeader-module__medical-tabs___d5882`,
	"medicalTableNew": `BGMFiltersHeader-module__medical-table-new___sqRth`,
	"noPagination": `BGMFiltersHeader-module__no-pagination___cZFHc`,
	"medicalTableEmpty": `BGMFiltersHeader-module__medical-table-empty___WsxMW`,
	"iconBtn": `BGMFiltersHeader-module__icon-btn___o6F3u`,
	"searchIcon": `BGMFiltersHeader-module__search-icon___I3Vzs`,
	"disableSelect": `BGMFiltersHeader-module__disable-select___VbXce`,
	"breakWord": `BGMFiltersHeader-module__break-word___XV7c3`,
	"popupClearBtn": `BGMFiltersHeader-module__popup-clear-btn___f3EuA`,
	"scrollMB20": `BGMFiltersHeader-module__scroll-m-b-20___WOFrO`,
	"container": `BGMFiltersHeader-module__container___kWULm`,
	"filters": `BGMFiltersHeader-module__filters___mq9yd`,
	"date": `BGMFiltersHeader-module__date___JC3uC`,
	"select": `BGMFiltersHeader-module__select___wq49Z`,
	"text": `BGMFiltersHeader-module__text___hEQCX`
};
module.exports = ___CSS_LOADER_EXPORT___;
